import debounce from "@mui/material/utils/debounce"
import { globalStore } from "../components/Index"
import { IndicatorClass } from "./indicator-class"
import { AppState } from "./redux-state"

let persistenceActive = false
export function activeStatePersistence() {
  if (persistenceActive) {
    return
  }
  persistenceActive = true
  globalStore.subscribe(
    // we use debounce to save the state
    // for better performances in case multiple changes occur in a short time
    debounce(() => {
      const state = globalStore.getState()
      saveState(state)
    }, 500)
  )
}

const KEY = "redux_v2_"
export function loadPersistedState(indicatorClass: IndicatorClass) {
  try {
    const serializedState = localStorage.getItem(KEY + indicatorClass)
    if (!serializedState) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    return undefined
  }
}

export async function saveState(state: AppState) {
  try {
    const indicatorClass = state.indicatorClass
    if (!indicatorClass) {
      console.error("cannot store state without indicatorClass")
      return
    }
    // sourceJson is refetched on every page load; persisting it would exceed
    // the localStorage quota for the large EWM JSONs
    const stateToPersist: AppState = { ...state, sourceJson: null }
    const serializedState = JSON.stringify(stateToPersist)
    try {
      localStorage.setItem(KEY + indicatorClass, serializedState)
    } catch (e) {
      // quota may still be filled by old persisted states that included sourceJson
      clearPersistedStates()
      localStorage.setItem(KEY + indicatorClass, serializedState)
    }
  } catch (e) {
    console.error(e)
  }
}

function clearPersistedStates() {
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith(KEY)) {
      localStorage.removeItem(key)
    }
  }
}
